import { combineReducers } from 'redux'

import AppReducer from 'store/reducers/App'
import ChatReducer from 'store/reducers/Chat'
import ChecklistReducer from 'store/reducers/Checklist'
import FeedbackReducer from 'store/reducers/Feedback'
import GesturesReducer from 'store/reducers/Gestures'
import QuizReducer from 'store/reducers/Quiz'
import RoomReducer from 'store/reducers/Room'
import UserReducer from 'store/reducers/User'
import WebSocketReducer from 'store/reducers/WebSocket'
import WhiteboardReducer from 'store/reducers/Whiteboard'

const rootReducer = combineReducers({
    app: AppReducer,
    quiz: QuizReducer,
    room: RoomReducer,
    feedback: FeedbackReducer,
    websocket: WebSocketReducer,
    gestures: GesturesReducer,
    whiteboard: WhiteboardReducer,
    user: UserReducer,
    checklist: ChecklistReducer,
    chat: ChatReducer,
})

export default rootReducer
